"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textSectionPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _util = require("./util");

var _commonPropTypes = _interopRequireDefault(require("../common-prop-types"));

require("./video-section.less");

var _sections = require("./sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {Object} props
 * @param {String} props.title
 * @param {String} props.subTitle
 * @param {String} props.headerClass
 * @param {Object} props.stringSubstitutions
 * @param {String} props.caption
 * @param {String} props.videoUrl
 * @param {String} props.className
 */
var VideoSection = function VideoSection(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      headerClass = _ref.headerClass,
      stringSubstitutions = _ref.stringSubstitutions,
      caption = _ref.caption,
      videoUrl = _ref.videoUrl,
      className = _ref.className;
  var titleString = (0, _util.stringSubstitution)(title, stringSubstitutions);

  var titleElement = title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: headerClass
  }, titleString);

  var subTitleElement = subTitle && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "subTitle"
  }, (0, _util.stringSubstitution)(subTitle, stringSubstitutions));

  var captionElement = caption && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "caption",
    source: (0, _util.stringSubstitution)(caption, stringSubstitutions)
  });

  var titleSection = (titleElement || subTitleElement) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "titleSection"
  }, titleElement, subTitleElement);

  var youtubeURL = videoUrl.replace('watch?v=', 'embed/');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "VideoSection ".concat(className)
  }, titleSection, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: titleString,
    width: "800",
    height: "400",
    src: youtubeURL
  }), captionElement);
};

var textSectionPropTypes = {
  title: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  caption: _propTypes["default"].string,
  videoUrl: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  headerClass: _propTypes["default"].string,
  stringSubstitutions: _commonPropTypes["default"].stringSubstitutions
};
exports.textSectionPropTypes = textSectionPropTypes;
VideoSection.propTypes = textSectionPropTypes;
VideoSection.defaultProps = {
  title: null,
  subTitle: null,
  caption: null,
  className: '',
  headerClass: 'h2',
  stringSubstitutions: {}
};
(0, _sections.registerWidget)('videoSection', VideoSection);
var _default = VideoSection;
exports["default"] = _default;